import _ from 'lodash';
import api from '@/services/api/index';

import {
  LOAD_STANDARDSTATI,
  LOAD_STANDARDTYPEN,
  LOAD_STANDARDGRUPPEN,
  LOAD_KATEGORIEN,
  LOAD_STANDARDSUBSTATI,
  LOAD_STANDORTE,
  LOAD_ANZAHL_STANDARD,
} from './actions.type';

import {
  SET_STANDARDSTATI,
  SET_STANDARDSTATI_LOADED,
  SET_STANDARDTYPEN,
  SET_STANDARDTYPEN_LOADED,
  SET_STANDARDGRUPPEN,
  SET_STANDARDGRUPPEN_LOADED,
  SET_STANDARDSUBSTATI,
  SET_STANDARDSUBSTATI_LOADED,
  SET_STANDORTE,
  SET_STANDORTE_LOADED,
  SET_ANZAHL_STANDARD,
} from './mutations.type';

import historie from './historie';
import { STANDARDBAU_SUBSTATI } from './getters.type';

function flattenNestedArray(arr) {
  const result = [];

  function recurse(items) {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of items) {
      // Objekt ohne childs kopieren, damit keine Referenzen bleiben
      const { childs, ...rest } = item;
      result.push(rest);

      if (Array.isArray(childs) && childs.length > 0) {
        recurse(childs);
      }
    }
  }

  recurse(arr);
  return result;
}

export default {
  namespaced: true,
  state: {
    standardstati: [],
    standardstati_loaded: false,
    standardsubstati: [],
    standardsubstati_loaded: false,
    standardtypen: [],
    _standardtypen_loaded: false,
    standardgruppen: [],
    standardgruppenFlat: [],
    _standardgruppen_loaded: false,
    standorte: [],
    standorteFlat: [],
    _standorte_loaded: false,
    anzahl_standard: null,
  },
  mutations: {
    [SET_STANDARDSTATI](state, val) {
      state.standardstati = val;
    },
    [SET_STANDARDSTATI_LOADED](state, val) {
      state.standardstati_loaded = val;
    },
    [SET_STANDARDSUBSTATI](state, val) {
      state.standardsubstati = val;
    },
    [SET_STANDARDSUBSTATI_LOADED](state, val) {
      state.standardsubstati_loaded = val;
    },
    [SET_STANDARDTYPEN](state, val) {
      state.standardtypen = val;
    },
    [SET_STANDARDTYPEN_LOADED](state, val) {
      state.standardtypen_loaded = val;
    },
    [SET_STANDARDGRUPPEN](state, val) {
      state.standardgruppen = val;
      state.standardgruppenFlat = flattenNestedArray(val);
    },
    [SET_STANDARDGRUPPEN_LOADED](state, val) {
      state.standardgruppen_loaded = val;
    },
    [SET_STANDORTE](state, val) {
      state.standorte = val;
      state.standorteFlat = flattenNestedArray(val);
    },
    [SET_STANDORTE_LOADED](state, val) {
      state.standorte_loaded = val;
    },
    [SET_ANZAHL_STANDARD](state, val) {
      state.anzahl_standard = val;
    },
  },
  actions: {

    async [LOAD_STANDARDSTATI]({ commit, state }, force = false) {
      if (state.standardstati_loaded && !force) {
        return state.standardstati;
      }
      const response = await api.v1.standard.status.get();
      commit(SET_STANDARDSTATI, response.data);
      commit(SET_STANDARDSTATI_LOADED, true);
      return response.data;
    },

    async [LOAD_STANDARDSUBSTATI]({ commit, state }, force = false) {
      if (state.standardsubstati_loaded && !force) {
        return state.standardsubstati;
      }
      const response = await api.v1.standard.status.getSubStati();
      commit(SET_STANDARDSUBSTATI, response.data);
      commit(SET_STANDARDSUBSTATI_LOADED, true);
      return response.data;
    },

    async [LOAD_STANDARDTYPEN]({ commit, state }, force = false) {
      if (state.standardtypen_loaded && !force) {
        return state.standardtypen;
      }
      const response = await api.v1.standard.typ.get();
      commit(SET_STANDARDTYPEN, response.data);
      commit(SET_STANDARDTYPEN_LOADED, true);
      return response.data;
    },

    async [LOAD_STANDARDGRUPPEN]({ commit, state }, force = false) {
      if (state.standardgruppen_loaded && !force) {
        return state.standardgruppen;
      }
      const response = await api.v1.standard.gruppe.get();
      commit(SET_STANDARDGRUPPEN, response.data);
      commit(SET_STANDARDGRUPPEN_LOADED, true);
      return response.data;
    },

    async [LOAD_STANDORTE]({ commit, state }, force = false) {
      if (state.standorte_loaded && !force) {
        return state.standorte;
      }
      const response = await api.v1.standard.standort.get();
      commit(SET_STANDORTE, response.data);
      commit(SET_STANDORTE_LOADED, true);
      return response.data;
    },

    async [LOAD_ANZAHL_STANDARD]({ commit }) {
      const response = await api.v1.standard.getAnzahl();
      commit(SET_ANZAHL_STANDARD, response.data);
      return response.data;
    },

    async [LOAD_KATEGORIEN]({ dispatch }) {
      await Promise.all([
        dispatch(LOAD_STANDARDSTATI),
        dispatch(LOAD_STANDARDSUBSTATI),
        dispatch(LOAD_STANDARDTYPEN),
        dispatch(LOAD_STANDARDGRUPPEN),
        dispatch(LOAD_STANDORTE),
      ]);
    },
  },
  modules: {
    historie,
  },
  getters: {
    [STANDARDBAU_SUBSTATI](state) {
      return _.chain(state.standardsubstati).filter((e) => e.standardbau === true).sortBy((e) => e.sort).value();
    },
  },
};
